import { ReactNode } from 'react';
import { IBeneficiaryData } from 'components/modules/Beneficiaries/Beneficiaries.model';
import { IApiResponse } from 'utils/models';

export const sortArrays = [
  'Source Account:',
  'Customer ID:',
  'Phone Number:',
  'Card Name:',
  'Card’s Last 4 Digits:',
  'Narration:',
  'Amount:',
];

export type TabsType = 0 | 1 | 2 | false;

export interface ICardsState {
  beneficiaries: IBeneficiaryData[];
}

export interface IFormValues {
  accountNumber: string;
  customerId: string;
  last4Digit: string;
  cardName: string;
  phoneNumber: string;
  amount: string;
  narration: string;
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}

export interface IValidatePrepaidCardResponse extends IApiResponse {
  customerId: string;
  balanceResponse: {
    balanceField: string;
    currencyCodeField: string;
    errorCodeField: string;
    errorMessageField: string;
  };
  customerResponse: {
    address1Field: string;
    alternatePhoneNumberField: string;
    birthDateField: string;
    cityField: string;
    countryField: string;
    emailAddressField: string;
    errorCodeField: string;
    errorMessageField: string;
    firstNameField: string;
    iDTypeField: string;
    iDValueField: string;
    lastNameField: string;
    middleNameField: string;
    mobilePhoneNumberField: string;
    postalCodeField: string;
    preferredNameField: string;
  };
}

export type IHandleFieldsChange = () => void;
